"use client";

import Link from "next/link";
import { useEffect, useState } from "react";

interface UserData {
  loggedIn: boolean;
  name: string;
}

interface SignInProps {
  accountUrl: string;
}

const SignIn: React.FC<SignInProps> = ({ accountUrl }) => {
  const [userData, setUserData] = useState<UserData>({
    loggedIn: false,
    name: "",
  });
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async (retries = 3, delay = 1000) => {
    if (window.ciamSDK) {
      try {
        const [loggedIn, userInfo] = await Promise.all([
          window.ciamSDK.getLoggedInState(),
          window.ciamSDK.getUserInfo(),
        ]);

        setUserData({
          loggedIn,
          name: userInfo?.name?.firstName || "",
        });
        setIsLoading(false);
      } catch (error) {
        if (retries > 0) {
          console.warn(`CIAM SDK error, retrying in ${delay}ms:`, error);
          setTimeout(() => fetchData(retries - 1, delay * 2), delay);
        } else {
          console.error("CIAM SDK failed after retries:", error);
          setIsLoading(false);
        }
      }
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const name = userData.name ? userData.name : "Account";
  const signedInText = userData.loggedIn ? name : "Sign In";

  return (
    <Link
      href={accountUrl}
      className="flex flex-col text-water text-center"
      data-tag-name="Sign in"
    >
      <i className="ico ico-account text-3xl"></i>
      <span className="font-body lg:font-heading text-xs lg:text-sm w-[4rem] truncate">
        {isLoading ? "Sign In" : signedInText}
      </span>
    </Link>
  );
};

export default SignIn;
